module.exports = __webpack_public_path__ + "fonts/Gotham-UltraItalic.5046e9bf.otf";